import MuiAccordionSummary, { AccordionSummaryProps as MuiAccordionSummaryProps } from '@mui/material/AccordionSummary';
import * as React from 'react';

export interface AccordionDetailProps extends MuiAccordionSummaryProps {}

export const AccordionSummary = (props: AccordionDetailProps) => {
  return <MuiAccordionSummary {...props} />;
};
